import { cn, mString } from 'lib/helpers/utility';

import Divider from 'components/shared/Divider/Divider';
import Typography from 'components/shared/Typography/Typography';
import CostLedger from 'components/Patient/checkin/SecurePayment/components/Letter/components/CostLedger';
import CoverageBreakdown from 'components/Patient/checkin/SecurePayment/components/Letter/components/CoverageBreakdown';

import { SAMPLE_CHECKIN } from '../../lib/constants';

const {
  totalCost,
  payments,
  paymentsBasisPoints,
  discounts,
  discountsBasisPoints,
  taxesAndFees,
  taxesBasisPoints,
  amountDue,
  patientBasisPoints,
  costShareLabel
} = SAMPLE_CHECKIN;

// Mirrors `Letter/components/EstimatedBalanceDue` with fixed sample figures.
const CheckinEstimateCard = ({ isNarrow = false }) => (
  <div className="flex flex-col gap-6">
    <div
      className={cn(
        'flex rounded-2xl bg-primary-to-white py-4',
        isNarrow ? 'flex-col gap-4 px-4' : 'items-start gap-12 pl-10 pr-0'
      )}>
      <div className="flex flex-1 flex-col gap-3 px-0 py-2">
        <div className="flex flex-col gap-2">
          <Typography
            variant="p"
            size="small"
            weight="medium"
            color="primary-500"
            className="uppercase">
            Your estimated portion today
          </Typography>
          <Typography variant="h2" weight="bold" color="primary-500">
            {mString(amountDue)}
          </Typography>
        </div>
        <div className="flex flex-col gap-1">
          <Typography variant="p" size="small" color="neutral-700">
            {costShareLabel}
          </Typography>
          <Typography variant="p" size="xs" color="neutral-600">
            Your share of this visit
            {taxesAndFees > 0 && `, plus ${mString(taxesAndFees)} in taxes and fees`}. No surprise
            balance expected.
          </Typography>
        </div>
      </div>
      {!isNarrow && <Divider direction="vertical" className="self-stretch" />}
      <div className={cn('flex w-full flex-1 flex-col gap-3', !isNarrow && 'pr-4')}>
        <CostLedger
          totalCost={totalCost}
          payments={payments}
          discounts={discounts}
          taxesAndFees={taxesAndFees}
          amountDue={amountDue}
          accentColor="primary-500"
        />
      </div>
    </div>
    <CoverageBreakdown
      payments={payments}
      paymentsBasisPoints={paymentsBasisPoints}
      discounts={discounts}
      discountsBasisPoints={discountsBasisPoints}
      taxesAndFees={taxesAndFees}
      taxesBasisPoints={taxesBasisPoints}
      patientAmount={amountDue}
      patientBasisPoints={patientBasisPoints}
    />
  </div>
);

export default CheckinEstimateCard;
